<template>
  <div class="authWrapper new-login-wrapper test">
    <div class="container">
      <div class="row login-white-wrap whiteBG-wrap">
        <div class="col-lg-7 col-md-7 no-padding">
          <div class="login-left-wrap">
            <transition :name="transitionName" mode="out-in">
              <component 
                :is="currentComponent" 
                :key="$route.path"
              />
            </transition>
          </div>
        </div>
        <div class="col-lg-5 col-md-5 no-padding">
           <LoginCarsoule />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MultiStepForm from "./MultiStepForm.vue";
import EmailLogin from "./EmailLogin.vue";
import PasswordLogin from "./PasswordLogin.vue";
import LoginCarsoule from "./Logincarsoule.vue";
export default {
  name: "Login",
  components: {
    LoginCarsoule,
    MultiStepForm,
    EmailLogin,
    PasswordLogin
  },
  computed: {
    currentComponent() {
  return this.$route.path === "/login"
    ? EmailLogin
    : PasswordLogin;
},
    transitionName() {
      return this.$route.path === "/login" ? "slide-right-fade" : "slide-left-fade";
    }
  },
};
</script>
<style src="@/assets/css/authen.css"></style>
<style src="@/assets/css/newLogin.css"></style>

<style>
#label-username,
#label-password {
  font-size: 16px !important;
  color: #909090 !important;
  margin-bottom: 10px !important;
}
#username,
#password {
  font-size: 14px !important;
  padding: 12px 15px !important;
}
.rep-icon-login {
  width: 80px;
}
.rep-icon-login img {
  width: 100px;
}
</style>

<style>
.multi-step-form {
  margin: auto;
}

.multi-step-form .invalid-feedback {
  color: #E73737;
  background-color: #FFE9E9;
  border-radius: 6px;
  padding: 0.5rem 0.8rem;
  margin-top: 0.1rem;
}

.multi-step-form .step-indicator {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.multi-step-form .step-indicator span {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.multi-step-form .step-indicator span.active {
  background-color: #007bff;
  color: white;
}

.multi-step-form  form {
  display: flex;
  flex-direction: column;
}

.multi-step-form label {
  margin-top: 10px;
}

.login-password-container {
  position: relative !important;
}

.login-toggle-eye-icon{
  position:absolute;
  top:10px;
  right:8px;
  cursor: pointer;
}


.login-password-container .is-valid {
  background-image: none !important;
}

.login-password-container .is-invalid {
  background-image: none !important;
}
  
.login-password-container .form-group{
        display: block !important;
}

</style>
